import React from 'react';
import { StyledCardWrapper } from './ShipInfoCard.styles';
import { Card } from '@sections/registry/components';
import { themeColor } from '@utils/styledTheme.util';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

export const ShipInfoCard = () => {
  const theme = useTheme();
  const { t } = useTranslation('registry');
  const shipInfoCard = t('registryCashFundSection.shipInfoCard');

  return (
    <StyledCardWrapper>
      <Card
        eyebrow={shipInfoCard.eyebrow}
        eyebrowColor="humanaDark4"
        eyebrowVariant="featureHed17"
        title={shipInfoCard.title}
        titleVariant="calloutHed32"
        titleColor="mono1"
        wrapperStyles={{
          backgroundColor: themeColor('humana1Light')({ theme }),
        }}
      />
    </StyledCardWrapper>
  );
};
